import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatIconModule } from '@angular/material/icon';

import { ZefScrollbarComponent } from '@zerops/zef/scrollbar';
import { RoleTranslatePipe } from '@zerops/zui/notification-item/role-translate.pipe';
import { ClientListItemModule } from '@zerops/zui/client-list-item';
import { ClientUserSelectContainer } from './client-user-select.container';

@NgModule({
  declarations: [ ClientUserSelectContainer ],
  imports: [
    CommonModule,
    MatListModule,
    MatTooltipModule,
    MatIconModule,
    ClientListItemModule,
    RoleTranslatePipe,
    ZefScrollbarComponent
  ],
  exports: [ ClientUserSelectContainer ]
})
export class ClientUserSelectModule {}
